module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SendBlessingsView.js"));
	}, "SendBlessingsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SendBlessingsView!./src/pages/Promote/PromoteHome/SendBlessings/SendBlessingsView.js
// module id = 1098
// module chunks = 438